import { Outlet } from "react-router";
import { Header } from "./header";
import { Footer } from "./footer";
import { ScrollToTop } from "./scroll-to-top";

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}